import {makeThemeProps} from "@themes/boost/props/utils";

export default (theme, site, props) => {
  const themeStyles = makeThemeProps(theme, site);
  return themeStyles.getProductCardProps(theme, props, site);
};
